'use strict';
import { pageReady, toggleSubmit, showAlert, request, RegexPatterns } from '../../app';

/* global FormValidation */

var Page = function () {

  // Handle form
  const initForm = function (form, submitButton = null) {

    // Get submit button
    if (!submitButton) submitButton = form.querySelector('button[type="submit"], button[data-action-submit]');

    // Form validation rules
    // For more info check the FormValidation plugin's official documentation: https://formvalidation.io
    const validator = FormValidation.formValidation(form,
      {
        fields: {
          'user_email': {
            validators: {
              notEmpty: {
                message: 'Email is required'
              },
              regexp: {
                flags: 'i',
                regexp: RegexPatterns.email,
                message: 'Format of email address is not valid'
              }
            }
          },
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger({
            // Validate these fields on these events
            event: {
              'user_email': 'blur change',
            }
          }),
          bootstrap: new FormValidation.plugins.Bootstrap5({
            rowSelector: '.form-group, .row',
          })
        }
      }
    );

    // Handle form submit
    submitButton.addEventListener('click', function (evt) {

      // Validate form
      validator.validate().then(function (status) {

        // Invalid fields, prevent button default action
        if (status != 'Valid') {
          evt.preventDefault();
          return;
        }

        // Cache email field
        const userEmail = form.querySelector('input[name="user_email"]');

        // Block submit button
        toggleSubmit(submitButton, false);

        // Send request to server via AJAX
        request('POST', form.action, { 'user_email': userEmail.value }).then(() => {

          // Show blocking success popup with button
          showAlert('A link to reset your password will be sent to the email address if it is associated with an account. Please check your email for further instructions.', false, true);

          // Reset form
          form.reset();
          toggleSubmit(submitButton, true);
        }); // End request
      }); // End validator

      // Since we are using AJAX, prevent default form submit action
      evt.preventDefault();
    });
  };

  // Public functions
  return {

    // Init
    init: function () {

      // Init form
      const form = document.querySelector('#resetForm');

      // Set focus to the first input field
      form.querySelector('input[name="user_email"]').focus();

      initForm(form);
    }
  };
}();

// On document ready
pageReady(Page.init);